const decode = (data: string) => Buffer.from(data, "base64").toString("utf-8");

export const encode = (data: string) => Buffer.from(data).toString("base64");

export const decodeBase64Id = (productId: string) =>
  decode(productId).split(":")[1];
